/* eslint-disable */
import ko from 'knockout';
import $ from 'jquery';
import _ from 'underscore';
import '@bingads-webui/kendo/kendo.datepicker';
ko.bindingHandlers.datePicker = {
  init: function (element, valueAccessor, allBindings) {
    var value = valueAccessor(), bindings = allBindings(), culture = bindings.culture, format = bindings.format, navigateToPastAriaLabel = bindings.navigateToPastAriaLabel, navigateToFutureAriaLabel = bindings.navigateToFutureAriaLabel, enabled = bindings.enabled, disabled = bindings.disabled;
    if (_.isUndefined(enabled) && !_.isUndefined(disabled)) {
      if (ko.isObservable(disabled)) {
        enabled = ko.computed(function () {
          return !disabled();
        });
      } else {
        enabled = !disabled;
      }
    }
    if (!ko.isObservable(value)) {
      throw new Error('Value accessor for date picker should be observable');
    }
    $(element).kendoDatePicker({
      culture: culture,
      format: format,
      animation: false,
      footer: false,
      max: new Date(9999, 11, 31),
      value: value(),
      change: function () {
        var val = this.value();
        if (val == null && !!$(element).val()) {
          val = $(element).val();
        }
        value(val);
      },
      open: function () {
        if (widget && widget.dateView && widget.dateView.calendar && widget.dateView.calendar.setOptions) {
          widget.dateView.calendar.setOptions({
            animation: false
          });
        }
        if (widget && widget.dateView && widget.dateView.calendar) {
          const {calendar} = widget.dateView;
          if (navigateToPastAriaLabel) {
            calendar._prevArrow.attr('aria-label', navigateToPastAriaLabel);
          }
          if (navigateToFutureAriaLabel) {
            calendar._nextArrow.attr('aria-label', navigateToFutureAriaLabel);
          }
        }
      }
    });
    $(element).addClass('form-control');
    var widget = $(element).data('kendoDatePicker');
    if (!!widget) {
      if (_.isFunction(widget.open)) {
        $(element).click(widget.open.bind(widget));
      }
      if (_.isFunction(widget.value)) {
        value.subscribe(function (newValue) {
          if (widget.value() != newValue) {
            widget.value(newValue);
          }
        });
      }
      if (ko.isObservable(enabled)) {
        widget.enable(enabled());
        enabled.subscribe(function (newValue) {
          widget.enable(newValue);
          $(element).removeAttr('aria-readonly');
        });
      } else if (!_.isUndefined(enabled)) {
        widget.enable(enabled);
      }
    }
    $(element).removeAttr('aria-readonly');
  }
};
export default ko.bindingHandlers.datePicker;

